// --no-test-for-file

import {fetchBaseQuery} from "@reduxjs/toolkit/query/react"
import {StoreState} from "../store"

// Настойки для API Review
export const apiConfig = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_STREAM,
  prepareHeaders: (headers, {getState}) => {
    const {auth} = getState() as StoreState
    const token = auth.token

    headers.set("Authorization", `Bearer ${token}`)
    return headers
  }
})
